// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los carteles
 * @param {*} scene 
 */
export function cargaAssetsCarteles(scene) {

  scene.load.spritesheet(
    "cartelNoVaMas",
    ROUTES.rutaRuletaCarteles + "/cartelNoVaMasResized-Sheet.png",
    {
      frameWidth: 228,
      frameHeight: 44,
    }
  );

  scene.load.spritesheet(
    "cartelHaganSusApuestas",
    ROUTES.rutaRuletaCarteles + "/cartelHaganSusApuestasResized-Sheet.png",
    {
      frameWidth: 228,
      frameHeight: 76,
    }
  );
  
}